<template>
	<div class="health-report">
		<div class="body">
			<div class="name">{{ value.name }}</div>
			<div class="responsible">{{ value.responsible }}</div>
			<div class="time-date">
				<div class="time">{{ value.date_hour | timeAgo(vue) }}</div>
				<div class="date">{{ value.date_hour | formatDate(vue) }}</div>
			</div>
			<div class="report">{{ value.report }}</div>
		</div>
		<div class="documents" v-if="value.attachments.length">
			<h1>Medical Documents</h1>
			<div class="attachments">
				<div v-for="attachment in value.attachments" :key="attachment.id" @click="downloadAttachment(attachment)" class="attachment">
					<svgicon name="health report" :fill="false" class="icon"/>
					<div class="filename">{{ attachment.name }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: [
		'value',
		'user_uid',
		'watch_id'
	],
	data () {
		return {
			vue: this,
			error: null
		}
	},
	methods: {
		getAttachmentMetadata (attachment) {
			const file_uid = attachment.file
			this.$api.files.getMetadata(this, this.user_uid, this.watch_id, file_uid).then(response => {
				this.$log.info('watch healthreports', 'files.getMetadata OK', response)()
				attachment.metadata = response.body
			}).catch(errors => {
				this.$log.error('watch healthreports', 'files.getMetadata ERROR', errors)()
				this.error = errors
			}).finally(() => {
				this.$forceUpdate()
			})
		},
		getAllAttachmentMetadata () {
			if (this.value.attachments) {
				this.value.attachments.forEach(attachment => {
					if (!attachment.metadata) {
						this.getAttachmentMetadata(attachment)
					}
				})
			}
		},
		downloadAttachment (attachment) {
			const file_uid = attachment.metadata.uid
			this.$api.files.get(this, this.user_uid, this.watch_id, file_uid).then(response => {
				this.$log.info('watch healthreports', 'files.get OK', response)()
				var arrayBuffer = response.body
				var blob = new Blob([arrayBuffer], { type: 'application/download' })
				let link = document.createElement('a')
				link.href = window.URL.createObjectURL(blob)
				link.download = attachment.name
				link.click()
			}).catch(errors => {
				this.$log.error('watch healthreports', 'files.get ERROR', errors)()
			})
		}
	},
	watch: {
		value (value) {
			this.error = null
			this.getAllAttachmentMetadata()
		}
	},
	mounted () {
		this.getAllAttachmentMetadata()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/healthreports/HealthReport.vue